import { render, staticRenderFns } from "./addAutoTemplate.vue?vue&type=template&id=b635745c&scoped=true&"
import script from "./addAutoTemplate.vue?vue&type=script&lang=js&"
export * from "./addAutoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./addAutoTemplate.vue?vue&type=style&index=0&id=b635745c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b635745c",
  null
  
)

export default component.exports